import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Divider,
  Chip,
  Button,
} from "@nextui-org/react"
import { useMessaging, useDictionary } from "@adamlip/okeoke.client"
import moment from "moment"
import { useNavigate } from "react-router-dom"

export default function NewsCard({ data }) {
  const { messagingLoggedIn, setArticleAction } = useMessaging()
  const { getValue } = useDictionary()
  const navigate = useNavigate()

  const handleMarkRead = () => {
    setArticleAction(data.uid, 1)
  }

  const handleClickMore = () => {
    handleMarkRead()
    navigate(`/newsfeed/${data.uid}`)
  }

  if (data == null) return null

  return (
    <Card className="max-w-[400px] shrink-0 mx-auto my-3 bg-[var(--news-bg)] text-[var(--news-text)] md:m-0 md:min-w-[400px]">
      <CardHeader className="flex gap-3">
        <div className="flex flex-col" id={data.uid}>
          <p className="text-md font-bold">{data.subject}</p>
          {data.severity > 0 && (
            <Chip color="warning" size="sm" className="my-1">
              {getValue("app_v2_news_card_important")}
            </Chip>
          )}
          <p className="text-small text-default-500">
            {moment(data.updateTimestamp).format("MMMM DD. HH:mm")}
          </p>
        </div>
      </CardHeader>
      <Divider />
      <CardBody>
        <p className="max-h-[100px] overflow-hidden">{data.message}</p>
        <span
          className="ml-auto opacity-70 text-sm cursor-pointer"
          onClick={() => handleClickMore()}
        >
          {getValue("app_v2_news_card_more")}
        </span>
      </CardBody>
      <Divider />
      {messagingLoggedIn && data.seen === 0 && (
        <CardFooter className="justify-end">
          <Button
            variant="light"
            color="primary"
            className="bg-[var(--news-buttonBg)] text-[var(--news-buttonText)]"
            onPress={() => handleMarkRead()}
          >
            {getValue("app_v2_news_card_mark_read")}
          </Button>
        </CardFooter>
      )}
    </Card>
  )
}
